//Core imports
import React, { Fragment, useState } from 'react';

//Component imports
import { Col, Grid, Radio, Row, Space, Typography } from 'antd';

//Misc imports
import { t } from 'i18next';
import ManualTranslationsView from '../UI/ManualTranslationsView';

// Constants
const { useBreakpoint } = Grid;

const TRANSLATION_RADIO_OPTIONS = {
  AUTOMATIC_TRANSLATIONS: {
    key: 'automatic-translations',
    label: t('Automatic Translations'),
    enabled: false,
    children: <Fragment> Automatic </Fragment> //TODO: TO BE IMPLEMENTED
  },
  MANUAL_TRANSLATIONS: {
    key: 'manual-translations',
    label: t('Manual Translations'),
    enabled: true,
    children: <ManualTranslationsView />
  }
};

const TranslationsForm = () => {
  const screens = useBreakpoint();
  const isMobileOrTabletSize = (screens.xs || screens.sm || screens.md || screens.lg) && !screens.xl;

  const [selectedRadioOption, setSelectedRadioOption] = useState(TRANSLATION_RADIO_OPTIONS.MANUAL_TRANSLATIONS.key);

  const onRadioOptionChange = (event) => {
    setSelectedRadioOption(event.target.value);
  };

  const renderRadioOption = (option) => (
    <Row className="flex-column w-100">
      <Col xs={24}>
        <Typography.Text className="fw-500 fs-base pb-4">
          {option.label}
        </Typography.Text>
      </Col>
      <Col xs={isMobileOrTabletSize ? 24 : 18}>
        {option.children}
      </Col>
    </Row>
  );

  const renderRadioGroup = () => {

    //TODO: When the design is ready remove the first condition and only leave the radio group
    const enabledRadioOptions = Object.values(TRANSLATION_RADIO_OPTIONS).filter(radioOption => radioOption.enabled);
    if(enabledRadioOptions?.length <= 1) {
      const radioOption = enabledRadioOptions[0];
      return renderRadioOption(radioOption);
    } else {
      return (
        <Fragment>
          <Radio.Group onChange={onRadioOptionChange} value={selectedRadioOption} defaultValue={TRANSLATION_RADIO_OPTIONS.MANUAL_TRANSLATIONS.key}>
            <Space direction="vertical">
              {
                enabledRadioOptions.map(radioOption => {
                  return <Radio
                    value={radioOption.key}
                  >
                    {renderRadioOption(radioOption)}
                  </Radio>;
                })
              }
            </Space>
          </Radio.Group>
        </Fragment>
      );
    }

  };

  return (
    <Fragment>
      {renderRadioGroup()}
    </Fragment>
  );
};

export default TranslationsForm;
